import styled from '@emotion/styled'

import IncreaseEngagementPng2x from './assets/IncreaseEngagement@2x.png'
import IncreaseEngagementWebp from './assets/IncreaseEngagement.webp'
import IncreaseEngagementWebp2x from './assets/IncreaseEngagement@2x.webp'
import IncreaseEngagementWebp3x from './assets/IncreaseEngagement@3x.webp'

const IncreaseEngagementImage = () => {
  return (
    <Picture>
      <source
        type="image/webp"
        srcSet={`${IncreaseEngagementWebp}, ${IncreaseEngagementWebp2x} 2x, ${IncreaseEngagementWebp3x} 3x`}
      />
      <Image
        src={IncreaseEngagementPng2x}
        alt="Illustration: Increase Engagement."
        width="559"
        height="596"
        loading="lazy"
      />
    </Picture>
  )
}

export default IncreaseEngagementImage

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

const Image = styled.img`
  display: block;
  height: auto;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    max-height: 346px;
    max-width: 346px;
  }
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    margin: auto;
    max-height: 420px;
    max-width: 420px;
  }
  image-rendering: -webkit-optimize-contrast;
`
